import { render, staticRenderFns } from "./user-share.vue?vue&type=template&id=61e8fe81&scoped=true"
import script from "./user-share.vue?vue&type=script&lang=js"
export * from "./user-share.vue?vue&type=script&lang=js"
import style0 from "./user-share.vue?vue&type=style&index=0&id=61e8fe81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e8fe81",
  null
  
)

export default component.exports